import React, { useEffect } from "react";
import { registerLocale } from "react-datepicker";
import fr from "date-fns/locale/fr";
import de from "date-fns/locale/de";
import it from "date-fns/locale/it";
import no from "date-fns/locale/nb";

import Skibig3SearchWidget from './skibig3.searchWidget';
import TyinSearchWidget from './tyin.searchWidget';
import TuruSearchWidget from "./turu.searchWidget";
import GaustaSearchWidget from './gausta.searchWidget';
import MoreysSearchWidget from "./moreyspiers.searchWidget";
import MoreysResortsSearchWidget from "./moreysresorts.searchWidget";
import BluePalmsSearchWidget from "./bluepalms.searchWidget";
import PanAmericanSearchWidget from "./panamerican.searchWidget";
import StarluxSearchWidget from "./starlux.searchWidget";
import PortRoyalSearchWidget from "./portroyal.searchWidget";
import SkiResortsSearchWidget from "./skiresorts.searchWidget";
import CransMontanaSearchWidget from "./cransmontana.searchWidget";
import PortfolioSearchWidget from "./portfolio.searchwdiget";

const isBluePalms = process.env.GATSBY_CONNECT_CLIENT === "bluepalmsmotel";
const isStarluxHotel = process.env.GATSBY_CONNECT_CLIENT === "starluxhotel";
const isPanAmerican = process.env.GATSBY_CONNECT_CLIENT === "panamericanhotel";
const isPortRoyal = process.env.GATSBY_CONNECT_CLIENT === "portroyalhotel";
const isMoreysResorts = process.env.GATSBY_CONNECT_CLIENT === "moreysresorts";
const isMoreysPiers = process.env.GATSBY_CONNECT_CLIENT === "moreyspiers";
const isSkiBig3 = process.env.GATSBY_CONNECT_CLIENT === "skibig3";
const isCransMontana = process.env.GATSBY_CONNECT_CLIENT === "mycma";
const isPortfolio = process.env.GATSBY_CONNECT_CLIENT === "spotlio-portfolio";
const isTurufjell = process.env.GATSBY_CONNECT_CLIENT === "turufjell";
const isTyinfilefjell = process.env.GATSBY_CONNECT_CLIENT === "tyinfilefjell";
const isGausta = process.env.GATSBY_CONNECT_CLIENT === "gausta";
const isSkiResortsTemplate = process.env.GATSBY_CONNECT_CLIENT === "skiresortstemplate";

const SearchWidgetSection = ({ selectedLanguage = "en-US", defaultLanguage, removeMargin = false }) => {

  useEffect(() => {
    if (selectedLanguage === "fr-FR") registerLocale("fr", fr);
    if (selectedLanguage === "it-IT") registerLocale("it", it);
    if (selectedLanguage === "de-DE") registerLocale("de", de);
    if (selectedLanguage === "no-NO") registerLocale("no", no);
    if (selectedLanguage === "nb-NO") registerLocale("nb", no);
    //eslint-disable-next-line
  }, [])


  const getSearchWidget = () => {
    if (isPortfolio) {
      return PortfolioSearchWidget(selectedLanguage);
    }
  }

  return (
    <div
      className={`flex w-full justify-center lg:px-10 relative z-[2] ${removeMargin ? "" : "mt-[-79px]"}`}
      style={{ filter: "drop-shadow(0px 2px 15px rgba(37, 37, 39, 0.15))" }}
    >
      {getSearchWidget()}
    </div>
  );
};

const exportedSearchWidget =
  false ? null
  : isGausta ? GaustaSearchWidget
  : isStarluxHotel ? StarluxSearchWidget
  : isPanAmerican ? PanAmericanSearchWidget
  : isPortRoyal ? PortRoyalSearchWidget
  : isBluePalms ? BluePalmsSearchWidget
  : isMoreysResorts ? MoreysResortsSearchWidget
  : isMoreysPiers ? MoreysSearchWidget
  : isSkiBig3 ? Skibig3SearchWidget
  : isTyinfilefjell ? TyinSearchWidget
  : isTurufjell ? TuruSearchWidget
  : isSkiResortsTemplate ? SkiResortsSearchWidget
  : isCransMontana ? CransMontanaSearchWidget
  : SearchWidgetSection;

export default exportedSearchWidget;



